// extracted by mini-css-extract-plugin
export default {"description":"VideoItem_description__g1gQH"};